import {
  OPEN_DAY_EDIT_NOTIFICATION_MODAL,
  CLOSE_DAY_EDIT_NOTIFICATION_MODAL,
  SET_NOTIFICATION_TYPE,
} from './types';

export const openEditNotificationModal = () => ({
  type: OPEN_DAY_EDIT_NOTIFICATION_MODAL,
});

export const closeEditNotificationModal = () => ({
  type: CLOSE_DAY_EDIT_NOTIFICATION_MODAL,
});

export const setNotificationType = ({ notificationType }) => ({
  type: SET_NOTIFICATION_TYPE,
  notificationType,
});



// WEBPACK FOOTER //
// ./src/redux/actions/alertModalActions.js